let viewgird = [
  // {
  //   path: '/MetCompMenu',
  //   name: 'MetCompMenu',
  //   component: () => import('@/views/method/method/MetCompMenu.vue')
  // },
  {
    path: '/RoomBoard',
    name: 'RoomBoard',
    component: () => import('@/views/method/method/RoomBoard.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/Dev_Report',
    name: 'Dev_Report',
    component: () => import('@/views/device/energy/Dev_Report.vue')
  },
  {
    path: '/Dev_EnergyStorageReport',
    name: 'Dev_EnergyStorageReport',
    component: () => import('@/views/device/energy/Dev_EnergyStorageReport.vue')
  },
  {
    path: '/Air_EnergyReport',
    name: 'Air_EnergyReport',
    component: () => import('@/views/device/air/Air_EnergyReport.vue')
  },
  {
    path: '/Dev_LineGraph2',
    name: 'Dev_LineGraph2',
    component: () => import('@/views/device/energy/Dev_LineGraph2.vue')
  },
  {
    path: '/Dev_LineGraph3',
    name: 'Dev_LineGraph3',
    component: () => import('@/views/device/energy/Dev_LineGraph3.vue')
  },
  {
    path: '/Dev_LineGraphView2',
    name: 'Dev_LineGraphView2',
    component: () => import('@/views/device/energy/Dev_LineGraphView2.vue')
  },
  {
    path: '/Dashboard_Energy',
    name: 'Dashboard_Energy',
    component: () => import('@/views/device/energy/Dashboard/Dashboard_Energy.vue')
  },
  {
    path: '/Dashboard_StationScreen',
    name: 'Dashboard_StationScreen',
    component: () => import('@/views/device/energy/Dashboard/Dashboard_StationScreen.vue')
  },
  // {
  //   path: '/Zt_Editor',
  //   name: 'Zt_Editor',
  //   component: () => import('@/views/zt/Zt_Editor.vue')
  // },
  {
    path: '/Zt_Viewer',
    name: 'Zt_Viewer',
    component: () => import('@/views/zt/Zt_Viewer.vue')
  },
  {
    path: '/Zt_Editor',
    name: 'Zt_Editor',
    component: () => import('@/views/zt/Zt_Meta2dEditor.vue')
  },
  {
    path: '/Zt_EnergyStorageDiagram',
    name: 'Zt_EnergyStorageDiagram',
    component: () => import('@/views/zt/Zt_EnergyStorageDiagram.vue')
  },
  {
    path: '/Dev_LineGraphView3',
    name: 'Dev_LineGraphView3',
    component: () => import('@/views/device/energy/Dev_LineGraphView3.vue')
  },
  {
    path: '/KanbanBoard',
    name: 'KanbanBoard',
    component: () => import('@/views/device/DeviceMonitor/KanBan.vue'),
    meta: {
      anonymous: true
    }
  },
  //大屏看板
  {
    path: '/KanBan',
    name: 'KanBan',
    component: () => import('@/views/device/DeviceMonitor/KanBan.vue')
  },
  {
    path: '/EnergyDashBoard',
    name: 'EnergyDashBoard',
    component: () => import('@/views/device/energy/Dashboard/EnergyDashBoard.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/MetCompMenuView',
    name: 'MetCompMenuView',
    component: () => import('@/views/method/method/MetCompMenuView.vue'),
    meta: {
      anonymous: true
    },
    children: [
      {
        path: 'MetDashboard',
        name: 'MetDashboard',
        component: () => import('@/views/method/method/MetDashboard.vue'),
        meta: {
          anonymous: true
        }
      },
      {
        path: 'MapViewNew',
        name: 'MapViewNew',
        component: () => import('@/views/method/method/MapViewNew.vue'),
        meta: {
          anonymous: true
        }
      }
    ]
  }
];

export default viewgird;
